import React, { useContext, useEffect, useState } from 'react'
import { ShopContext } from '../context/ShopContext'
import Title from '../components/Title';
import { assets } from '../assets/assets';
import CartTotal from '../components/CartTotal';
import { Helmet } from 'react-helmet'

const Cart = () => {

  const { products , currency , cartItems, updateQuantity , navigate,token } = useContext(ShopContext);
  const [cartData,setCartData] = useState([]);
  const [loading, setLoading] = useState(true);

  if(!token){
    navigate('/login');}

  useEffect(()=>{
    setLoading(true);
    if (products.length > 0) {
      const tempData = [];
      for(const items in cartItems){
        for(const item in cartItems[items]){
          let entry = cartItems[items][item];
          let quantity = typeof entry === 'object' ? entry.quantity : entry;
          if (quantity > 0) {
            tempData.push({
              _id: items,
              size: item,
              quantity,
              color: typeof entry === 'object' ? entry.color : null,
              measurements: typeof entry === 'object' ? entry.measurements : null
            });
          }
        }
      }
      setCartData(tempData);
      setTimeout(() => setLoading(false), 800); // Simulate loading effect
    }
  },[cartItems,products])

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen bg-gray-50 animate-pulse">
        <div className="w-full max-w-3xl mx-auto p-8 rounded-2xl bg-white/80 shadow-lg flex flex-col gap-8">
          <div className="h-24 bg-gray-200 rounded-xl mb-6 relative overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 animate-gradient-x" style={{backgroundSize:'200% 100%'}}></div>
          </div>
          <div className="flex flex-col gap-4">
            <div className="h-8 w-2/3 bg-gray-200 rounded"></div>
            <div className="h-6 w-1/3 bg-gray-200 rounded"></div>
            <div className="h-10 w-1/2 bg-gray-200 rounded"></div>
            <div className="h-4 w-1/4 bg-gray-200 rounded"></div>
          </div>
          <div className="flex gap-4 mt-8">
            <div className="h-12 w-32 bg-gray-200 rounded-full"></div>
            <div className="h-12 w-32 bg-gray-200 rounded-full"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className='bg-white text-gray-800 border-t pt-14 px-4 sm:px-8 lg:px-16'>
      <Helmet>
        <title>My Cart - Sahla Curtain Center</title>
      </Helmet>
      
      <div className='text-2xl mb-6'>
        <Title text1={'YOUR'} text2={'CART'} />
      </div>

      {cartData.length === 0 ? (
        <div className='text-center py-20'>
          <p className='text-xl text-gray-600'>Your cart is empty. Why not add some beautiful items?</p>
          <button 
            onClick={() => navigate('/collection')} 
            className='mt-8 bg-black text-white text-sm px-10 py-4 rounded-md shadow-lg hover:bg-gray-900 transition duration-300'
          >
            START SHOPPING
          </button>
        </div>
      ) : (
        <>
          <div className='hidden sm:grid grid-cols-[4fr_2fr_0.5fr] text-gray-600 font-semibold border-b pb-3 mb-4'>
            <p>Product</p>
            <p className='text-center'>Quantity</p>
            <p className='text-center'>Remove</p>
          </div>

          <div>
            {
              cartData.map((item,index)=>{
                const productData = products.find((product)=> product._id === item._id);
                return(
                  <div key={index} className='py-4 border-b border-gray-200 text-gray-700 grid grid-cols-[4fr_0.5fr_0.5fr] sm:grid-cols-[4fr_2fr_0.5fr] items-center gap-4 hover:bg-gray-50 transition duration-200 rounded-md'>
                    <div className='flex items-center gap-6'>
                      <img src={productData.image[0]} alt={productData.name} className='w-16 h-16 sm:w-24 sm:h-24 object-cover rounded-md shadow-sm' />
                      <div>
                        <p className='text-sm sm:text-xl font-medium text-gray-900'>{productData.name}</p>
                        <div className='flex items-center gap-4 mt-2 text-gray-600'>
                          <p className='font-semibold'>{currency}{productData.price}</p>
                          <span className='px-2 py-1 bg-gray-100 text-xs sm:text-sm rounded-full'>{item.size}</span>
                          {item.color && (
                            <span className='px-2 py-1 bg-blue-100 text-xs sm:text-sm rounded-full flex items-center gap-2'>
                              <span className='inline-block w-4 h-4 rounded-full border border-gray-300' style={{backgroundColor: item.color}}></span>
                              <span>Color</span>
                            </span>
                          )}
                          {item.measurements && (
                            <span className='px-2 py-1 bg-green-100 text-xs sm:text-sm rounded-full'>
                              {`H: ${item.measurements.H} ${item.measurements.measurementUnit}, W: ${item.measurements.W} ${item.measurements.measurementUnit}`}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className='flex justify-center'>
                      <input 
                        onChange={(e)=> e.target.value === '' || e.target.value === '0' ? null : updateQuantity(item._id ,item.size ,Number(e.target.value), item.color, item.measurements)} 
                        className='border border-gray-300 max-w-16 sm:max-w-24 px-2 py-1 rounded-md text-center focus:outline-none focus:ring-2 focus:ring-blue-400' 
                        type="number" 
                        min={1} 
                        defaultValue={item.quantity} 
                      />
                    </div>
                    <div className='flex justify-end pr-4 sm:pr-0'>
                      <img 
                        onClick={()=> updateQuantity(item._id , item.size , 0, item.color, item.measurements)} 
                        className='w-6 h-6 sm:w-7 sm:h-7 cursor-pointer opacity-70 hover:opacity-100 transition duration-200' 
                        src={assets.bin_icon} 
                        alt="Remove item" 
                      />
                    </div>
                  </div>
                )
              })
            }
          </div>

          <div className='flex flex-col sm:flex-row justify-between items-start sm:items-end my-16 gap-8'>
            <div className='w-full sm:w-auto p-6 bg-gray-50 rounded-lg shadow-md'>
              <h3 className='text-xl font-semibold mb-4 text-gray-900'>Need Help?</h3>
              <p className='text-gray-700 leading-relaxed'>
                If you have any questions about your order, our products, or anything else, feel free to contact our customer support. We&apos;re here to help!
              </p>
              <button 
                className='mt-4 text-sm text-blue-600 hover:underline'
                onClick={() => alert('Navigate to contact page or open a chat widget')} // Example: replace with actual navigation
              >
                Contact Us
              </button>
            </div>

            <div className='w-full sm:w-[450px] bg-white p-6 rounded-lg shadow-lg'>
              <CartTotal/>
              <div className='w-full text-end mt-8 flex flex-col gap-4'>
                <button 
                  onClick={()=> navigate('/place-order')} 
                  className='bg-black text-white text-sm px-8 py-3 rounded-md shadow-lg hover:bg-gray-900 transition duration-300 w-full'
                >
                  PROCEED TO CHECKOUT
                </button>
                <button 
                  onClick={()=> navigate('/collection')} 
                  className='bg-gray-200 text-gray-800 text-sm px-8 py-3 rounded-md shadow-md hover:bg-gray-300 transition duration-300 w-full'
                >
                  CONTINUE SHOPPING
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export default Cart